import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { MOCK_GIFTS } from '../../data/mockData';
import { GiftCard } from '../GiftCard';
interface GiftHistoryScreenProps {
  onBack: () => void;
  onRedeem: (gift: any) => void;
}
export function GiftHistoryScreen({
  onBack,
  onRedeem
}: GiftHistoryScreenProps) {
  const [activeTab, setActiveTab] = useState<'received' | 'sent'>('received');
  const filteredGifts = MOCK_GIFTS.filter(g => activeTab === 'received' ? g.recipient === 'You' : g.sender === 'You');
  return <div className="pb-24 pt-6 px-4 animate-in slide-in-from-right duration-300" data-id="element-745">
      <div className="flex items-center gap-3 mb-6" data-id="element-746">
        <button onClick={onBack} className="p-2 bg-white rounded-full shadow-sm" data-id="element-747">
          <ArrowLeft size={20} data-id="element-748" />
        </button>
        <h1 className="text-xl font-bold text-gray-900" data-id="element-749">Gift Wallet</h1>
      </div>

      {/* Tabs */}
      <div className="flex p-1 bg-gray-100 rounded-xl mb-6" data-id="element-750">
        <button onClick={() => setActiveTab('received')} className={`flex-1 py-2 text-sm font-bold rounded-lg transition-all ${activeTab === 'received' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500'}`} data-id="element-751">
          Received
        </button>
        <button onClick={() => setActiveTab('sent')} className={`flex-1 py-2 text-sm font-bold rounded-lg transition-all ${activeTab === 'sent' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500'}`} data-id="element-752">
          Sent
        </button>
      </div>

      {/* List */}
      <div className="space-y-4" data-id="element-753">
        {filteredGifts.map(gift => <GiftCard key={gift.id} gift={gift} onClick={() => activeTab === 'received' && gift.status !== 'redeemed' ? onRedeem(gift) : null} data-id="element-754" />)}
        {filteredGifts.length === 0 && <div className="text-center py-12 text-gray-400" data-id="element-755">
            <p data-id="element-756">No gifts found</p>
          </div>}
      </div>
    </div>;
}